class InfiniteCarousel {
  constructor() {
    this.carousel = document.querySelector(".carousel");
    this.items = document.querySelectorAll(".carousel-item");
    this.itemWidth = 0;
    this.currentIndex = 0;
    this.isDesktop = window.innerWidth >= 1024;
    this.visibleItems = this.isDesktop ? 7 : 3;
    this.autoScrollInterval = null;
    this.init();
  }

  init() {
    // Clone items for infinite effect
    const itemsToClone = Array.from(this.items).map((item) =>
      item.cloneNode(true)
    );
    itemsToClone.forEach((item) => this.carousel.appendChild(item));

    // Set initial position
    this.updateItemWidth();
    this.updateCarouselPosition();
    this.startAutoScroll();

    // Handle resize
    window.addEventListener("resize", () => {
      this.isDesktop = window.innerWidth >= 1024;
      this.visibleItems = this.isDesktop ? 7 : 3;
      this.updateItemWidth();
      this.updateCarouselPosition();
    });
  }

  updateItemWidth() {
    const containerWidth = this.carousel.parentElement.offsetWidth;
    this.itemWidth = containerWidth / this.visibleItems;
    document.querySelectorAll(".carousel-item").forEach((item) => {
      item.style.width = `${this.itemWidth}px`;
    });
  }

  updateCarouselPosition() {
    const offset = -this.currentIndex * this.itemWidth;
    this.carousel.style.transform = `translateX(${offset}px)`;
    this.updateActiveClasses();
  }

  updateActiveClasses() {
    document.querySelectorAll(".carousel-item").forEach((item, index) => {
      item.classList.remove("active", "active-1", "active-2", "active-3");

      const normalizedIndex =
        (index - this.currentIndex + this.items.length) % this.items.length;
      const middleIndex = Math.floor(this.visibleItems / 2);

      if (normalizedIndex === middleIndex) {
        item.classList.add("active");
      } else if (
        normalizedIndex === middleIndex - 1 ||
        normalizedIndex === middleIndex + 1
      ) {
        item.classList.add("active-1");
      } else if (
        normalizedIndex === middleIndex - 2 ||
        normalizedIndex === middleIndex + 2
      ) {
        item.classList.add("active-2");
      } else {
        item.classList.add("active-3");
      }
    });
  }

  startAutoScroll() {
    this.autoScrollInterval = setInterval(() => {
      this.currentIndex++;
      if (this.currentIndex >= this.items.length) {
        this.currentIndex = 0;
        this.carousel.style.transition = "none";
        this.updateCarouselPosition();
        setTimeout(() => {
          this.carousel.style.transition = "transform 0.5s ease-in-out";
        }, 30);
      } else {
        this.updateCarouselPosition();
      }
    }, 2000);
  }
}

// Initialize carousel when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new InfiniteCarousel();
});
